module.exports = __webpack_public_path__ + "static/media/bike-at-storefront.33d3b37d.jpg";